export const AcquisitionConstants = {
  Acquisition: {
    INFO_CUBIC: "Info Cubic",
    DEFAULT: "Orange Tree",
  },
};
